import React from 'react';
import { ScaleLoader } from 'react-spinners';
import {
  makeStyles,
  createStyles,
  useTheme,
  Theme,
} from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(createStyles({
  override: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
  },
  spinnerWrapper: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2147483100,
  },
}), { name: 'Spinner' });

type Props = {
  className?: string;
  withWrapper?: boolean;
};

const Spinner = ({ className, withWrapper = false }: Props) => {
  const classes = useStyles();
  const theme = useTheme<Theme>();

  return (
    <div className={clsx(classes.override, className, {
      [classes.spinnerWrapper]: withWrapper,
    })}
    >
      <ScaleLoader
        color={theme.colors.brandPrimary}
        loading
      />
    </div>
  );
};

export default Spinner;
